import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
  }

  User:any;
   RememberMeData = {};
 
   rememberMe:boolean;
   isRegistering:boolean;
 
   loginUserName:string;
   loginPassword:string;
   logoImage:string;
 
   ngOnInit(): void {
     
     this.rememberMe = false;
     this.isRegistering = false;
 
     let RememberMeJSON:string = this.cookieService.get('RememberUser');
 
     if(RememberMeJSON !== undefined && RememberMeJSON != null && RememberMeJSON.length){
       this.RememberMeData = JSON.parse(RememberMeJSON);
       this.rememberMe = true;
 
       this.loginUserName = this.RememberMeData["username"];
       this.loginPassword = this.RememberMeData["password"];
     }
 
     this.logoImage = this.service.ImagesServiceUrl + "/B2B/foxline_automation_icon.png";
     this.SetDefaultLanguage();
   }
 
   SetDefaultLanguage(){
 
     if(this.getLanguage() == ''){
       this.setLanguage("en");
     }
   }
 
   DeleteRememberedCredentials(){
 
     if(!this.rememberMe == false){
       this.cookieService.delete("RememberUser", "/");
     }
   }
 
     signin: FormGroup = new FormGroup({
     email: new FormControl('', [Validators.email, Validators.required ]),
     password: new FormControl('', [Validators.required, Validators.min(3) ]),
     confirmPassword: new FormControl('', [Validators.required, Validators.min(3) ]),
     username: new FormControl('', [Validators.required, Validators.min(3) ]),
     phone:new FormControl('', [Validators.required, Validators.min(3) ]),
     name: new FormControl('', [Validators.required, Validators.min(3) ]),
   });
 
   hide = true;
   hideCPassword = true;
   loading = false;
 
   get emailInput() { return this.signin.get('email'); }
   get passwordInput() { return this.signin.get('password'); }
   get confirmPasswordInput() { return this.signin.get('confirmPassword'); }
   get usernameInput() { return this.signin.get('username'); }
   get nameInput() { return this.signin.get('name'); }
   get phoneInput() { return this.signin.get('phone'); }
 
   RegisterNewUser(){
 
      var request = {
        Email:this.signin.controls['email'].value,
        Password:this.signin.controls['password'].value,
        ConfirmPassword:this.signin.controls['confirmPassword'].value,
        username:this.signin.controls['username'].value,
        phone:this.signin.controls['phone'].value,
        UIName:this.signin.controls['name'].value,
        Language:this.getLanguage()
      };
      
      this.loading = true;
 
     this.service.RegisterNewUser(request).subscribe(response => {
         
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else{
         this.isRegistering = false;
         this.loginUserName = this.signin.controls['username'].value;
         this.loginUserName = this.signin.controls['email'].value;
         this.loginPassword = this.signin.controls['password'].value;
         this.rememberMe = true;
         this.Login();
       }
 
       this.loading = false;
 
     });
   }
 
   LoginResponse = {};
   ShowMFA:boolean;
   MFAToken:string;
 
   Login(){
 
     this.LoginResponse = {};
 
     var request = {
        username:this.loginUserName,
        email:this.loginUserName,
        password:this.loginPassword,
        Language:this.getLanguage()
     };
 
     this.loading = true;
 
     this.service.Login(request).subscribe(response => {
 
       if(this.rememberMe){
         this.cookieService.set( 'RememberUser', JSON.stringify(request), 5, "/");
       }
 
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         this.loading = false;
       }
       else if(response["Status"] == 1){
         this.User = response["User"];
         this.LoginResponse["Status"] = response["Status"];
         this.LoginResponse["Message"] = response["Message"];
         this.setLanguage(this.User.Settings.Language.Name.toLowerCase());
         this.translate.use(this.User.Settings.Language.Name.toLowerCase());
 
         var App = this.User.AppAccess.find(x => x.IsSelected == true);
 
         if(App == null || App?.Application?.RequiresToken == true){
           localStorage.setItem('User', JSON.stringify(this.User));
           setTimeout(()=>{                           
           this.router.navigate(['login/MFA']);
           this.loading = false;
          }, 1000);
         }
         else{
           localStorage.setItem('User', JSON.stringify(this.User));
           setTimeout(()=>{                           
           this.router.navigate(['login/success/company/select']);
           this.loading = false;
          }, 1000);
         }
       }
     });
   }
 
   ProcessMFA(){
     let MFATokenCookie:any = this.cookieService.get('MFAuthToken');
 
     if(MFATokenCookie !== undefined && MFATokenCookie != null && MFATokenCookie.length > 0){
       localStorage.setItem('User', JSON.stringify(this.User));
       setTimeout(()=>{                           
         this.router.navigate(['login/success/company/select'])
         this.loading = false;
     }, 1000);
     }
     else{
        this.loading = false;
        this.ShowMFA = true;
     }
   }
 
   VerifyMFAToken(){
     var request = {
       User:this.User,
       Language:this.getLanguage(),
       Token:this.MFAToken
     };
 
     this.loading = true;
 
     this.service.VerifyMFAToken(request).subscribe(response => {
 
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         this.loading = false;
       }
       else if(response["Status"] == 1){
           this.cookieService.set( 'MFAuthToken', JSON.stringify(true), 5, "/");
 
           localStorage.setItem('User', JSON.stringify(this.User));
           setTimeout(()=>{                           
             this.router.navigate(['login/success/company/select'])
             this.loading = false;
         }, 1000);
       }
     });
   }
 
   openSnackBar(message: string, action: string, designClass: string) {
     this._snackBar.open(message, action, {
       duration: 5000,
       panelClass: [designClass]
     });
   }
 
   SendRecoverPasswordEmail(){
     var request = {
       UserName:this.loginUserName,
       Language:this.getLanguage()
     };
 
     this.loading = true;
 
     this.service.SendRecoverPasswordEmail(request).subscribe(response => {
 
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         this.loading = false;
       }
       else if(response["Status"] == 1){
         this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       }
 
       this.loading = false;
     });
   }

}
